import { useMemo } from 'react';
import { useAppRouter } from './useAppRouter';

/** Read-only search params surface, aligned with `next/navigation` / RR7 reads. */
type AppSearchParams = Omit<
  URLSearchParams,
  'append' | 'delete' | 'set' | 'sort'
>;

/** RR7-shaped tuple; setter slot deferred until navigation backend supports it. */
type UseSearchParamsResult = readonly [searchParams: AppSearchParams];

const getSearchFromAsPath = (asPath: string): string => {
  const queryIndex = asPath.indexOf('?');
  if (queryIndex < 0) {
    return '';
  }

  return asPath.slice(queryIndex + 1).split('#')[0] ?? '';
};

/**
 * Returns URL search params parsed from the current route's `asPath`.
 * Tuple shape matches React Router 7's `useSearchParams`; setter omitted for now.
 */
export const useSearchParams = (): UseSearchParamsResult => {
  const { asPath } = useAppRouter();
  const search = getSearchFromAsPath(asPath);

  return useMemo(() => [new URLSearchParams(search)], [search]);
};
